// extracted by mini-css-extract-plugin
export default {"card":"k7-z"};